import { call, put, takeLatest } from "redux-saga/effects";
import { getUserVerify, putUserVerify, setUserVerify, putUserVerifySucess, deleteUserVerify } from "../slices/UserVerifySlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { DeleteUserVerifyParam, FetchUserVerifyParam } from "@/Interfaces/I_userVerify";
import { AxiosResponse } from "axios";
import { deleteUserVerifyApi, fetchUserVerifyApi, putUserVerifyApi } from "@/Axios/api/userVerify";
import { message } from "antd";

function* handleGetUserVerify(action: PayloadAction<FetchUserVerifyParam>) {
  try{
    const data: AxiosResponse = yield call(fetchUserVerifyApi, action.payload);
    yield put(setUserVerify(data));
  } catch (e) {
    console.log(e)
  }
}

function* handlePutUserVerify(action: PayloadAction<String[]>) {
  try{
    const data: AxiosResponse = yield call(putUserVerifyApi, action.payload);
    if (data.data.unhandledUuid.length > 0) {
      message.error({
        content: `Following uuid is either not exist or error occured: ${data.data.toString()}`,
        duration: 3,
        style: {
          marginTop: '120px',
        },
      })
    }
    yield put(putUserVerifySucess(data.data.editedUser))
    message.success({
      content: 'User updated.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }
  catch (e) {
    message.error({
      content: `Error Occured: ${e}`,
        duration: 5,
        style: {
          marginTop: '120px',
        },
    })
  }
}

function* handldDeleteUserVerify(action: PayloadAction<DeleteUserVerifyParam>) {
  try{
    const data: AxiosResponse = yield call(deleteUserVerifyApi, action.payload.deleteUserUuid);
    if (data.status === 200) {
      message.success({
        content: 'User updated.',
        duration: 3,
        style: {
          marginTop: '120px',
        },
      });
      const fetchParam = {
        hybrisId: action.payload.hybrisId,
        uuid: action.payload.uuid,
        name: action.payload.name,
        kocUserRole: action.payload.kocUserRole,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize
      }

      yield put(getUserVerify(fetchParam));
    }
  } catch (e) {
    message.error({
      content: `Error Occured during user edit: ${e}`,
        duration: 5,
        style: {
          marginTop: '120px',
        },
    })
  }
}

export function* watchGetUserVerify() {
  yield takeLatest(getUserVerify.type, handleGetUserVerify)
}

export function* watchPutUserVerify() {
  yield takeLatest(putUserVerify.type, handlePutUserVerify)
}

export function* watchDeleteUserVerify() {
  yield takeLatest(deleteUserVerify.type, handldDeleteUserVerify)
}